import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, Outlet } from 'react-router-dom'

import { LanguageSwitcher, Spinner } from '@/shared/ui'
import { Logo } from '@/shared/ui/brand'

/**
 * Pantalla de acceso (login, registro, recuperar clave, hub de perfiles):
 * mismo patrón que `/login` en safyro-contadores/safyro-fintrack — logo
 * centrado arriba, tarjeta flotando sobre el fondo de marca, sin el shell de
 * sidebar (nadie que llega aquí tiene sesión todavía). Cada página sigue
 * armando su propio `mx-auto max-w-md` + `Card`; este layout solo pone el
 * marco alrededor.
 */
export default function AuthLayout() {
  const { t } = useTranslation()

  return (
    <div className="humania-page flex min-h-full flex-col">
      <header className="flex items-center justify-between gap-4 px-4 py-6 sm:px-8">
        <Link to="/" aria-label={t('app.name')}>
          <Logo className="h-8" />
        </Link>
        <LanguageSwitcher />
      </header>

      <main className="flex flex-1 items-center justify-center px-4 py-8">
        <div className="w-full">
          <Suspense fallback={<Spinner />}>
            <Outlet />
          </Suspense>
        </div>
      </main>

      <footer className="px-4 py-6 text-center text-xs text-ink-400">
        {t('marketing.copyright', { year: new Date().getFullYear() })}
      </footer>
    </div>
  )
}
